import { render } from "./CodeTabletFormComponent.vue?vue&type=template&id=44db8364"
import script from "./CodeTabletFormComponent.vue?vue&type=script&lang=js"
export * from "./CodeTabletFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__